module.exports = __webpack_public_path__ + "static/ocorie-srv-splash-img-comptia-81e2a91e7549f952385dfbc6e1079379.png";